import * as React from "react";

const SVGEasyApproval = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_1607_61)" />
        <circle
          cx="20"
          cy="20"
          r="19.5"
          stroke="url(#paint1_linear_1607_61)"
          stroke-opacity="0.22"
        />
      </g>
      <path
        d="M17.9967 12.1061C18.5605 11.6256 18.8425 11.3853 19.1372 11.2444C19.819 10.9185 20.6116 10.9185 21.2934 11.2444C21.5882 11.3853 21.8702 11.6256 22.434 12.1061C22.6584 12.2973 22.7707 12.393 22.8905 12.4733C23.1652 12.6574 23.4737 12.7852 23.7982 12.8493C23.9397 12.8772 24.0867 12.8889 24.3806 12.9124C25.1191 12.9713 25.4884 13.0008 25.7964 13.1096C26.509 13.3613 27.0694 13.9217 27.3211 14.6343C27.4299 14.9423 27.4594 15.3116 27.5183 16.0501C27.5418 16.344 27.5535 16.491 27.5814 16.6325C27.6455 16.957 27.7733 17.2655 27.9574 17.5402C28.0377 17.66 28.1333 17.7722 28.3246 17.9967C28.8051 18.5605 29.0454 18.8425 29.1863 19.1372C29.5122 19.819 29.5122 20.6116 29.1863 21.2934C29.0454 21.5882 28.8051 21.8702 28.3246 22.434C28.1333 22.6584 28.0377 22.7707 27.9574 22.8905C27.7733 23.1652 27.6455 23.4737 27.5814 23.7982C27.5535 23.9397 27.5418 24.0867 27.5183 24.3806C27.4594 25.1191 27.4299 25.4884 27.3211 25.7964C27.0694 26.509 26.509 27.0694 25.7964 27.3211C25.4884 27.4299 25.1191 27.4594 24.3806 27.5183C24.0867 27.5418 23.9397 27.5535 23.7982 27.5814C23.4737 27.6455 23.1652 27.7733 22.8905 27.9574C22.7707 28.0377 22.6584 28.1333 22.434 28.3246C21.8702 28.8051 21.5882 29.0454 21.2934 29.1863C20.6116 29.5122 19.819 29.5122 19.1372 29.1863C18.8425 29.0454 18.5605 28.8051 17.9967 28.3246C17.7722 28.1333 17.66 28.0377 17.5402 27.9574C17.2655 27.7733 16.957 27.6455 16.6325 27.5814C16.491 27.5535 16.344 27.5418 16.0501 27.5183C15.3116 27.4594 14.9423 27.4299 14.6343 27.3211C13.9217 27.0694 13.3613 26.509 13.1096 25.7964C13.0008 25.4884 12.9713 25.1191 12.9124 24.3806C12.8889 24.0867 12.8772 23.9397 12.8493 23.7982C12.7852 23.4737 12.6574 23.1652 12.4733 22.8905C12.393 22.7707 12.2973 22.6584 12.1061 22.434C11.6256 21.8702 11.3853 21.5882 11.2444 21.2934C10.9185 20.6116 10.9185 19.819 11.2444 19.1372C11.3853 18.8425 11.6256 18.5605 12.1061 17.9967C12.2973 17.7722 12.393 17.66 12.4733 17.5402C12.6574 17.2655 12.7852 16.957 12.8493 16.6325C12.8772 16.491 12.8889 16.344 12.9124 16.0501C12.9713 15.3116 13.0008 14.9423 13.1096 14.6343C13.3613 13.9217 13.9217 13.3613 14.6343 13.1096C14.9423 13.0008 15.3116 12.9713 16.0501 12.9124C16.344 12.8889 16.491 12.8772 16.6325 12.8493C16.957 12.7852 17.2655 12.6574 17.5402 12.4733C17.66 12.393 17.7722 12.2973 17.9967 12.1061Z"
        fill="var(--primary-theme-color)"
        fill-opacity="0.2"
        stroke="var(--primary-theme-color)"
        stroke-width="1.5"
      />
      <path
        d="M16.7153 20.7153L18.7153 22.7153L23.7153 17.7153"
        stroke="var(--primary-theme-color)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1607_61"
          x1="0.885609"
          y1="20"
          x2="39.5572"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F4FFF7" />
          <stop offset="1" stop-color="#F4FFF7" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1607_61"
          x1="0.442805"
          y1="26.9231"
          x2="40.0012"
          y2="26.8806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--primary-theme-color)" />
          <stop
            offset="1"
            stop-color="var(--primary-theme-color)"
            stop-opacity="0"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SVGEasyApproval;
